import { ImageTransformer } from "../types";
import grailedTransformer from "./grailedTransformer";

export const TRANSFORMERS: Record<string, ImageTransformer | undefined> = {
  "media.grailed.com": grailedTransformer,
  "media-assets.grailed.com": grailedTransformer,
  "external-media.grailed.com": grailedTransformer,
};
